import { createMiddleware } from "@tanstack/react-start";
import { loginRedirect } from "#/modules/util.auth/login-redirect.server";
import { getAuthSession } from "#/modules/util.auth/session.auth.server";

/**
 * Function middleware that enforces an authenticated session on a server function.
 * Route `beforeLoad` guards are UX only — attach this to every server function that
 * touches private data so the RPC rejects when called directly without a session.
 */
export const authMiddleware = createMiddleware({ type: "function" }).server(async ({ next }) => {
  const session = await getAuthSession();
  const user = session.data.user;
  const tokens = session.data.tokens;
  if (!user || !tokens?.accessToken) {
    throw loginRedirect();
  }
  return next({ context: { user, tokens } });
});
